import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/Icon'
import { fromNowDatetimeUtil } from 'utils/datetime'
import {
  getStatusColorOrderUtil,
  getTrackingUrlOrderUtil
} from 'models/daos/order/utils'
import { BoxIcon } from 'components/Icon/icons/box'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'

class OrderRowBody extends React.Component {
  static defaultProps = {
    url: null
  }

  static propTypes = {
    isSmallScreen: PropTypes.bool,
    order: PropTypes.object,
    url: PropTypes.string,
    promoCodes: PropTypes.arrayOf(
      PropTypes.object
    )
  }

  renderIcon () {
    const props = {
      icon: BoxIcon,
      color: getStatusColorOrderUtil(
        getValueReduxUtil(this.props.order, 'status')
      ),
      size: Icon.SIZE.BIGGEST
    }
    const isSmallScreen = this.props.isSmallScreen
    const paddingRight = isSmallScreen ? null : STYLES_PADDING.BIG
    const paddingBottom = isSmallScreen ? STYLES_PADDING.BIG : null
    return (
      <div
        style={{
          paddingBottom,
          paddingRight
        }}
      >
        <Icon {...props} />
      </div>
    )
  }

  renderKey () {
    const { order } = this.props
    return (
      <span>
        <strong>Order: #{getValueReduxUtil(order, 'key')}</strong>
      </span>
    )
  }

  renderLastUpdate () {
    const updatedAt = new Date(
      getValueReduxUtil(this.props.order, 'updatedAt')
    )
    return (
      <span>
        <span>
          Last Update: {fromNowDatetimeUtil(updatedAt)}
        </span>
      </span>
    )
  }

  renderTracking () {
    const trackingUrl = getTrackingUrlOrderUtil(this.props.order)
    if (!trackingUrl || this.props.url) {
      return
    }
    return (
      <a
        href={trackingUrl}
        style={{ color: STYLES_COLOR.BLUE }}
      >
        Tracking
      </a>
    )
  }

  render () {
    const isSmallScreen = this.props.isSmallScreen
    return (
      <View
        style={{
          flexDirection: isSmallScreen
            ? View.DIRECTION.COLUMN
            : View.DIRECTION.ROW,
          alignItems: View.ALIGN.CENTER
        }}
      >
        {this.renderIcon()}
        <View>
          {this.renderKey()}
          {this.renderLastUpdate()}
          {this.renderTracking()}
        </View>
      </View>
    )
  }
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(OrderRowBody)
